import { isFeatureEnabled } from '@lumapps/features';

export const REPORT_FF = 'report';

/** Reports feature enabled. */
export const isReportFeatureEnabled = isFeatureEnabled(REPORT_FF);
